import core from './core'
import cdu from './cdu'
import kansas from './kansas'
import rpcService from './rpcService'
import WebSocketLiveService from './webSocketLiveService'
import betting from './betting'

export default {
  core,
  cdu,
  kansas,
  rpcService,
  WebSocketLiveService,
  betting
}



// WEBPACK FOOTER //
// ./src/library/index.js